"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputTime_styles_1 = __importDefault(require("./InputTime.styles"));
var InputTime = function (_a) {
    var label = _a.label, name = _a.name, _b = _a.value, value = _b === void 0 ? '12:00' : _b, valueChanged = _a.valueChanged;
    return (react_1.default.createElement(InputTime_styles_1.default, null,
        label && react_1.default.createElement("label", null, label),
        react_1.default.createElement("input", { type: "time", name: name, value: value, onChange: function (e) {
                if (valueChanged)
                    valueChanged(e.currentTarget.value);
            } })));
};
exports.default = InputTime;
